import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ 
  searchTerm, 
  onSearchChange, 
  selectedIndustry, 
  onIndustryChange,
  selectedComplexity,
  onComplexityChange,
  selectedCompanySize,
  onCompanySizeChange,
  onClearFilters,
  resultCount 
}) => {
  const industryOptions = [
    { value: '', label: 'All Industries' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'retail', label: 'Retail & Consumer' },
    { value: 'automotive', label: 'Automotive' },
    { value: 'chemicals', label: 'Chemicals' },
    { value: 'utilities', label: 'Utilities' },
    { value: 'pharma', label: 'Pharmaceuticals' },
    { value: 'oil-gas', label: 'Oil & Gas' },
    { value: 'banking', label: 'Banking & Financial Services' }
  ];

  const complexityOptions = [
    { value: '', label: 'All Complexity Levels' },
    { value: 'low', label: 'Low - Basic Implementation' },
    { value: 'medium', label: 'Medium - Standard Features' },
    { value: 'high', label: 'High - Advanced Configuration' },
    { value: 'expert', label: 'Expert - Custom Development' }
  ];

  const companySizeOptions = [
    { value: '', label: 'All Company Sizes' },
    { value: 'small', label: 'Small (< 500 employees)' },
    { value: 'medium', label: 'Medium (500-5000 employees)' },
    { value: 'large', label: 'Large (5000+ employees)' },
    { value: 'enterprise', label: 'Enterprise (Global Operations)' }
  ];

  const hasActiveFilters = selectedIndustry || selectedComplexity || selectedCompanySize || searchTerm;

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Filter Best Practices</h3>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Filter" size={16} />
          <span>{resultCount} practices found</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div className="lg:col-span-1">
          <Input
            type="search"
            placeholder="Search practices..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Industry Filter */}
        <div className="lg:col-span-1">
          <Select
            placeholder="Select industry"
            options={industryOptions}
            value={selectedIndustry}
            onChange={onIndustryChange}
            searchable
          />
        </div>

        {/* Complexity Filter */}
        <div className="lg:col-span-1">
          <Select
            placeholder="Select complexity"
            options={complexityOptions}
            value={selectedComplexity}
            onChange={onComplexityChange}
          />
        </div>

        {/* Company Size Filter */}
        <div className="lg:col-span-1">
          <Select
            placeholder="Select company size"
            options={companySizeOptions}
            value={selectedCompanySize}
            onChange={onCompanySizeChange}
          />
        </div>
      </div>
      {hasActiveFilters && (
        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="FilterX" size={16} />
            <span>Active filters applied</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear All
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterControls;